export enum CardsSuccessCodes {
  CARD_NUMBER_COPIED = 'card_number_copied',
  CARD_CVV_COPIED = 'card_cvv_copied',
  CARD_EXP_DATE_COPIED = 'card_exp_date_copied',
  CARD_FROZEN = 'card_frozen',
  CARD_UNFROZEN = 'card_unfrozen',
  CARD_RENAMED = 'card_renamed',
  CARD_UNBLOCKED = 'card_unblocked',
  CARD_ACTIVATED = 'card_activated',
}
